import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { ValidateJLCsvFileResponse } from "../../domain/requests/plans/ValidateJLCsvFileResponse";


@Injectable({ providedIn: 'root' })
export class ValidateJLCsvFileUseCase implements UseCase<FormData,ValidateJLCsvFileResponse> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param: FormData): Observable<ValidateJLCsvFileResponse> {
    return this.planRepository.validateJobsCSV(param);
  }

}